import { render } from "./AdultTeeth.vue?vue&type=template&id=6c44415c&scoped=true"
import script from "./AdultTeeth.vue?vue&type=script&lang=js"
export * from "./AdultTeeth.vue?vue&type=script&lang=js"

import "./AdultTeeth.vue?vue&type=style&index=0&id=6c44415c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c44415c"]])

export default __exports__